import * as React from 'react';
import styled, { css } from 'styled-components';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';
import { useGetConfigQuery } from '../../../API/applicationConfig/ApplicationConfigAPI';
import NonprodSpruceLogo from '../../images/nonprod/spruce/logo.svg?react';
import NonprodZillowLogo from '../../images/nonprod/zillow/logo.svg?react';
import PreprodSpruceLogo from '../../images/preprod/spruce/logo.svg?react';
import PreprodZillowLogo from '../../images/preprod/zillow/logo.svg?react';
import PreviewSpruceLogo from '../../images/preview/spruce/logo.svg?react';
import PreviewZillowLogo from '../../images/preview/zillow/logo.svg?react';
import ProdSpruceLogo from '../../images/prod/spruce/logo.svg?react';
import ProdZillowLogo from '../../images/prod/zillow/logo.svg?react';

const LogoCSS = css`
  width: 125px;
  height: 56px;
  margin-top: -9px;
`;

const styledLogo = (Logo: React.ComponentType<React.SVGProps<SVGSVGElement>>) =>
  styled(Logo)`
    ${LogoCSS}
  `;

// vite-plugin-svgr 4.x resolves `?react` imports statically, so the logos can no
// longer be pulled in through a template-literal dynamic import. Environment
// folders come from configuration.imagesFolder; the brand comes from the
// pinecone.zillow-closing feature flag.
const logosByFolderAndBrand: Record<string, Record<string, React.ComponentType>> = {
  nonprod: { spruce: styledLogo(NonprodSpruceLogo), zillow: styledLogo(NonprodZillowLogo) },
  preprod: { spruce: styledLogo(PreprodSpruceLogo), zillow: styledLogo(PreprodZillowLogo) },
  preview: { spruce: styledLogo(PreviewSpruceLogo), zillow: styledLogo(PreviewZillowLogo) },
  prod: { spruce: styledLogo(ProdSpruceLogo), zillow: styledLogo(ProdZillowLogo) },
};

export const LogoImage: React.FC = () => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const { data: configuration } = useGetConfigQuery();

  const brand = isZillowClosingEnabled ? 'zillow' : 'spruce';
  const folder = configuration?.imagesFolder;
  const Logo = folder ? logosByFolderAndBrand[folder]?.[brand] : undefined;

  return Logo ? <Logo /> : null;
};
